export default {
  namespaced: true,
  state: {
    gatewayScrollTop: 0
  },
  mutations: {
    getGatewayScrollTop(state, data) {
      state.gatewayScrollTop = data.toString();
    }
  }
};
